
import angular from "angular";
import { RestfulAccessorProvider } from "./data-access/restful/restful-accessor.provider";

let name = "qp-core-accessor";

angular.module(name, [])
    .provider({
        $accessor: RestfulAccessorProvider,
    })

export { name }
